import { render } from "./Shout.svg?vue&type=template&id=a1bb642e"
const script = {}
script.render = render

export default script